module.exports = __webpack_public_path__ + "static/media/s2.65341955.svg";